/* tokamoka storefront redesign — behaviour
   - collection filter pills (instant, client-side, ?f= query param) + progressive page loading
   - product page: variant pills, gallery thumbs, sticky mobile bar
   - Toka Bulucu quiz
   Cart adds are handled by the theme's <product-form> element (opens the cart drawer). */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return s + '₺';
  }

  /* ---------- header: phone menu ---------- */
  $$('[data-tk-header]').forEach(function (header) {
    var btn = $('[data-tk-burger]', header);
    var nav = $('[data-tk-nav]', header);
    if (!btn || !nav) return;
    function isOpen() { return header.classList.contains('is-open'); }
    function setOpen(open) {
      header.classList.toggle('is-open', open);
      document.body.classList.toggle('tk-menu-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    }
    btn.addEventListener('click', function () { setOpen(!isOpen()); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('click', function (e) { if (isOpen() && !header.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); } });
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1024px)');
      var onChange = function (m) { if (m.matches && isOpen()) setOpen(false); };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
    }
  });

  /* ---------- collection: filters + progressive loading ---------- */
  function initCollection(root) {
    var pills = $$('.tk-filter', root);
    var grid = $('[data-tk-grid]', root) || $('.tk-grid', root);
    var count = $('[data-tk-count]', root);
    var empty = $('.tk-empty', root);
    var more = $('[data-tk-more]', root);
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var current = 'all';
    var loading = false;

    function tiles() { return $$('.tk-tile[data-tags]', root); }

    function apply(key, push) {
      current = key;
      var n = 0;
      tiles().forEach(function (t) {
        var tags = (t.getAttribute('data-tags') || '').split(' ');
        var show = key === 'all' || tags.indexOf(key) !== -1;
        t.classList.toggle('is-hidden', !show);
        if (show) n++;
      });
      pills.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-filter') === key ? 'true' : 'false'); });
      /* while later pages are still unloaded, "all" means the whole collection */
      if (count) count.textContent = (key === 'all' && more && total ? total : n) + ' karakter';
      if (empty) empty.hidden = n !== 0 || (key !== 'all' && !!more);
      if (push) {
        var url = new URL(window.location.href);
        if (key === 'all') url.searchParams.delete('f'); else url.searchParams.set('f', key);
        history.replaceState(null, '', url.toString());
      }
    }

    /* progressive loading: the "Daha fazla göster" link is enhanced into an in-place loader,
       and a sentinel near the end of the grid loads the next page before the reader reaches it */
    function updateMore(shown, totalItems) {
      if (!more) return;
      var txt = $('[data-tk-more-text]', more);
      var bar = $('.tk-more__bar span', more);
      if (txt) txt.textContent = shown + ' / ' + totalItems + ' karakter gösteriliyor';
      if (bar) bar.style.width = Math.round(shown * 100 / Math.max(totalItems, 1)) + '%';
    }

    function loadNext() {
      if (!more || loading) return Promise.resolve(false);
      var next = more.getAttribute('data-next');
      if (!next) return Promise.resolve(false);
      loading = true;
      more.classList.add('is-loading');
      var btn = $('[data-tk-more-btn]', more);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Yükleniyor…'; btn.setAttribute('aria-busy', 'true'); }
      var url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', more.getAttribute('data-section'));
      return fetch(url.toString(), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = document.createDocumentFragment();
          $$('.tk-tile', doc).forEach(function (t) { frag.appendChild(document.importNode(t, true)); });
          if (empty && empty.parentNode === grid) grid.insertBefore(frag, empty); else grid.appendChild(frag);
          var nextMore = $('[data-tk-more]', doc);
          if (nextMore && nextMore.getAttribute('data-next')) {
            more.setAttribute('data-next', nextMore.getAttribute('data-next'));
            if (btn) btn.setAttribute('href', nextMore.getAttribute('data-next'));
            updateMore(nextMore.getAttribute('data-shown'), nextMore.getAttribute('data-total'));
          } else {
            updateMore(more.getAttribute('data-total'), more.getAttribute('data-total'));
            more.classList.remove('is-loading');
            more.classList.add('is-done');
            more = null;
          }
          document.dispatchEvent(new CustomEvent('tk:collection:loaded', { detail: { root: root } }));
          return true;
        })
        .catch(function () {
          /* on a network error fall back to the plain link */
          if (more) more.classList.remove('is-loading');
          return false;
        })
        .then(function (ok) {
          loading = false;
          if (more) { more.classList.remove('is-loading'); if (btn) { btn.textContent = label; btn.removeAttribute('aria-busy'); } }
          apply(current, false);
          return ok;
        });
    }

    function loadAll() {
      return loadNext().then(function (ok) { return ok && more ? loadAll() : ok; });
    }

    if (more) {
      var btn = $('[data-tk-more-btn]', more);
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });
      var sentinel = $('[data-tk-more-sentinel]', more);
      if (sentinel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (en) { return en.isIntersecting; })) return;
          loadNext().then(function (ok) {
            if (!more) { io.disconnect(); return; }
            /* short viewport: the sentinel may still be on screen, keep going */
            if (ok && sentinel.getBoundingClientRect().top < window.innerHeight + 600) loadNext();
          });
        }, { rootMargin: '600px 0px' });
        io.observe(sentinel);
      }
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var key = p.getAttribute('data-filter');
        apply(key, true);
        /* a filter should cover the whole collection, so pull in the remaining pages */
        if (key !== 'all' && more) loadAll();
      });
    });
    var initial = new URL(window.location.href).searchParams.get('f') || root.getAttribute('data-initial-filter') || 'all';
    if (!pills.some(function (p) { return p.getAttribute('data-filter') === initial; })) initial = 'all';
    apply(initial, false);
    if (initial !== 'all' && more) loadAll();
  }
  $$('[data-tk-collection]').forEach(initCollection);

  /* ---------- product page ---------- */
  function initProduct(root) {
    var data = $('[data-tk-product-json]', root);
    var product = null;
    try { product = JSON.parse(data.textContent); } catch (e) { product = null; }
    var mainImg = $('[data-tk-main-image]', root);
    var thumbs = $$('.tk-thumb', root);
    var variantBtns = $$('.tk-variant', root);
    var idInputs = $$('input[name="id"]', root);
    var priceEls = $$('[data-tk-price]', root);
    var atcLabels = $$('[data-tk-atc-label]', root);
    var atcButtons = $$('button[name="add"]', root);

    /* the main <img> carries a srcset, so swapping only .src would be ignored by the browser: swap both */
    function setMain(src, alt, srcset) {
      if (!mainImg || !src) return;
      if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
      mainImg.src = src;
      if (alt) mainImg.alt = alt;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-src') === src ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setMain(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-srcset')); });
    });

    function selectVariant(id) {
      if (!product) return;
      var v = product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      idInputs.forEach(function (i) { i.value = v.id; });
      variantBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-id')) === String(v.id) ? 'true' : 'false'); });
      priceEls.forEach(function (p) { p.textContent = money(v.price); });
      var label = v.available ? ('Sepete Ekle · ' + money(v.price)) : 'Tükendi';
      atcLabels.forEach(function (l) { l.textContent = label; });
      atcButtons.forEach(function (b) { b.disabled = !v.available; });
      if (v.featured_image && v.featured_image.src) setMain(v.featured_image.src, v.featured_image.alt, v.featured_image.srcset);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
    }
    variantBtns.forEach(function (b) {
      b.addEventListener('click', function () { selectVariant(b.getAttribute('data-id')); });
    });

    /* sticky bar: show once the main buy button scrolls out of view */
    var sticky = $('.tk-sticky', root);
    var anchor = $('[data-tk-buy-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      document.body.classList.add('tk-has-sticky');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }
  $$('[data-tk-product]').forEach(initProduct);

  /* ---------- Toka Bulucu quiz ---------- */
  function initQuiz(root) {
    var questions = [];
    try { questions = JSON.parse($('[data-tk-questions]', root).textContent); } catch (e) { return; }
    var map = {};
    try { map = JSON.parse($('[data-tk-outcomes]', root).textContent); } catch (e) { map = {}; }
    var eyebrow = $('[data-tk-progress]', root);
    var ask = $('[data-tk-ask]', root);
    var h1 = $('[data-tk-q]', root);
    var hint = $('[data-tk-hint]', root);
    var opts = $('[data-tk-opts]', root);
    var back = $('[data-tk-back]', root);
    var resultWrap = $('[data-tk-result]', root);
    var results = $$('.tk-result', root);
    var retry = $$('[data-tk-retry]', root);
    var qa = [];
    try { qa = JSON.parse(sessionStorage.getItem('tk_quiz') || '[]'); if (!Array.isArray(qa)) qa = []; } catch (e) { qa = []; }

    function outcome() {
      var q1 = qa[0], q2 = qa[1], q3 = qa[2];
      var key;
      if (q3 === 1) key = 'kizim';
      else if (q3 === 2) key = q2 === 1 ? 'hediye_pembe' : 'hediye';
      else key = ['kendim_0', 'kendim_1', 'kendim_2', 'kendim_3'][q2];
      if (q1 === 0 && q2 === 0 && q3 === 0) key = 'override';
      return map[key] || map['hediye'];
    }

    function render() {
      try { sessionStorage.setItem('tk_quiz', JSON.stringify(qa)); } catch (e) { /* ignore */ }
      var n = qa.length;
      if (n >= 3) {
        ask.hidden = true; resultWrap.hidden = false;
        eyebrow.textContent = 'Toka bulucu · sonuç';
        var handle = outcome();
        results.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-handle') === handle); });
        return;
      }
      ask.hidden = false; resultWrap.hidden = true;
      var q = questions[n];
      eyebrow.textContent = 'Toka bulucu · ' + (n + 1) + '/3';
      h1.textContent = q.q;
      hint.textContent = q.hint;
      opts.innerHTML = '';
      q.options.forEach(function (label, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tk-opt'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
        b.innerHTML = '<span></span><span aria-hidden="true">→</span>';
        b.firstChild.textContent = label;
        b.addEventListener('click', function () { qa.push(i); render(); window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' }); });
        opts.appendChild(b);
      });
      back.hidden = n === 0;
    }
    back.addEventListener('click', function () { qa.pop(); render(); });
    retry.forEach(function (b) { b.addEventListener('click', function () { qa = []; render(); }); });
    render();
  }
  $$('[data-tk-quiz]').forEach(initQuiz);

  /* ---------- hero showcase: the store's own products take turns in the panel ---------- */
  $$('[data-tk-showcase]').forEach(function (root) {
    var items = $$('.tk-showcase__item', root);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3200;
    var i = 0, timer = null, paused = false, inView = true;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (it, k) {
        var on = k === i;
        it.classList.toggle('is-active', on);
        it.setAttribute('aria-hidden', on ? 'false' : 'true');
        var a = $('a', it);
        if (a) a.tabIndex = on ? 0 : -1;
      });
    }
    function tick() { if (!paused && inView && !document.hidden) show(i + 1); }
    function start() { if (!timer) timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (!items.length) return;
    show(0);
    if (items.length < 2 || reduce) return;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });

  /* ---------- hero video: the built-in clip ships as small theme-asset parts; stitch and play ---------- */
  $$('video[data-tk-video-parts]').forEach(function (v) {
    var urls = [];
    try { urls = JSON.parse(v.getAttribute('data-tk-video-parts')); } catch (e) { return; }
    if (!urls.length || !window.fetch || !window.Blob) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Promise.all(urls.map(function (u) { return fetch(u).then(function (r) { if (!r.ok) throw new Error(u); return r.arrayBuffer(); }); }))
      .then(function (bufs) {
        var blob = new Blob(bufs, { type: 'video/mp4' });
        v.src = URL.createObjectURL(blob);
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* poster stays */ });
      })
      .catch(function () { /* poster stays */ });
  });

  /* ---------- newsletter: inline states from Shopify's redirect ---------- */
  $$('[data-tk-newsletter]').forEach(function (form) {
    var msg = $('.tk-newsform__msg', form);
    if (!msg) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('customer_posted') === 'true') { msg.textContent = 'Teşekkürler, listedesin.'; msg.hidden = false; }
  });
})();
